module.exports = __webpack_public_path__ + "static/havelsan_tsk_news-5637647a6ed0e22b531ffa9995cc1202.png";